import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { $serializer3hxquo1mpwg0w as $serializer } from './EntryChange.mjs';
import { ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.CollectionChanges', null, 1);
        tmp0_serialDesc.a1b('changes', true);
        this.l3l_1 = tmp0_serialDesc;
      }
      b2j(typeSerial0) {
        return $serializer_0().g3o(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer_0() {
  if ($serializerClass === VOID) {
    class $ {
      static h3o() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.CollectionChanges', $this, 1);
        tmp0_serialDesc.a1b('changes', true);
        $this.e3o_1 = tmp0_serialDesc;
        return $this;
      }
      i3o(encoder, value) {
        var tmp0_desc = this.e3o_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 0)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$0 = emptyList();
          tmp = !equals(value.j3o_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 0, new (ArrayListSerializer())($serializer().m3o(this.f3o_1)), value.j3o_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.i3o(encoder, value instanceof CollectionChanges() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.e3o_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_input = decoder.l13(tmp0_desc);
        if (tmp5_input.a14()) {
          tmp4_local0 = tmp5_input.x13(tmp0_desc, 0, new (ArrayListSerializer())($serializer().m3o(this.f3o_1)), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.x13(tmp0_desc, 0, new (ArrayListSerializer())($serializer().m3o(this.f3o_1)), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp5_input.m13(tmp0_desc);
        return CollectionChanges().n3o(tmp3_bitMask0, tmp4_local0, null);
      }
      az() {
        return this.e3o_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [new (ArrayListSerializer())($serializer().m3o(this.f3o_1))];
      }
      s1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.f3o_1];
      }
      static g3o(typeSerial0) {
        var $this = this.h3o();
        $this.f3o_1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var CollectionChangesClass;
function CollectionChanges() {
  if (CollectionChangesClass === VOID) {
    class $ {
      toString() {
        return 'CollectionChanges(changes=' + toString(this.j3o_1) + ')';
      }
      hashCode() {
        return hashCode(this.j3o_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CollectionChanges()))
          return false;
        if (!equals(this.j3o_1, other.j3o_1))
          return false;
        return true;
      }
      static n3o(seen0, changes, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, Companion_getInstance().l3l_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.listOf' call
          tmp.j3o_1 = emptyList();
        } else
          $this.j3o_1 = changes;
        return $this;
      }
    }
    initMetadataForClass($, 'CollectionChanges', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    CollectionChangesClass = $;
  }
  return CollectionChangesClass;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstanceqo1s9uxbxjme,
};
//endregion

//# sourceMappingURL=CollectionChanges.mjs.map
